import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { WhatsApp as WhatsAppIcon, Settings as SettingsIcon } from '@mui/icons-material';

export const WhatsAppManageIcon = (props: SvgIconProps) => {
  return (
    <div style={{ position: 'relative', width: 24, height: 24 }}>
      <WhatsAppIcon {...props} style={{ position: 'absolute', top: 0, left: 0 }} />
      <SettingsIcon 
        {...props} 
        style={{ 
          position: 'absolute', 
          bottom: -6, 
          right: -6, 
          transform: 'scale(0.6)', 
          backgroundColor: '#1976d2',
          borderRadius: '50%',
        }} 
      />
    </div>
  );
};
